module.exports = __webpack_public_path__ + "static/img/349.f401aef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200513/349.jpg
// module id = WA4S
// module chunks = 0